/*************************************************/
/* VIDEO                                         */
/*************************************************/

export function video() {
    let $video;

    const init = function () {
        $video = $(".video-item__player");

        // Video
        if ($video.length) {
            $video.on('click', function () {

                if (typeof YT === "undefined" || typeof YT.Player === "undefined") {
                    return;
                }

                const that = $(this);
                const playerId = that.data("playerid");
                const videoId = that.data("videoid");
                let playerName = `_${playerId}`;

                playerName = new YT.Player(playerId, {
                    height: "100%",
                    width: "100%",
                    videoId: videoId,
                    host: "https://www.youtube-nocookie.com",
                    events: {
                        "onReady": onPlayerReady,
                        "onStateChange": onPlayerStateChange
                    },
                    playerVars: {
                        showinfo: 0,
                        rel: 0
                    }
                });

                function onPlayerReady(event) {
                    event.target.playVideo();
                    that.addClass("video-item__player--playing");
                }

                function onPlayerStateChange(event) {
                    if (event.data === YT.PlayerState.ENDED) {
                        playerName.destroy();
                        that.removeClass("video-item__player--playing");
                    }
                }
            });
        }
    };

    init();
}